<template>
  <div class="c-card payment">
    <div>
      <div class="c-card--title">
        <h3>{{$t('card-payment.cards')}}</h3>
      </div>
      <div class="c-card--content" v-if="!loading">
        <credit-card v-for="(item, index) in cards" :index="index" :key="item.getId()" :item="item" :data="item" />
      </div>
      <div class="c-card--content" v-else>
        <loader />
      </div>
      <div class="c-card--footer" v-if="!loading">
        <button class="colored-btn red-btn" @click="openModal()">
          <i class="las la-plus"></i> {{$t('card-payment.addCard')}}
        </button>
      </div>
    </div>
    <add-card-modal :opened="modalOpenState" @close="handleModalClose"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CreditCard from '../../../components/credit-card';
import AddCardModal from './add-card-modal';
import Loader from '../../../components/loader.component';

export default {
  name: 'card-payment',
  components: { AddCardModal, CreditCard, Loader },
  computed: mapState({
    loading: s => s.stripeCard.loading,
    cards: s => s.stripeCard.cards.sort((a, b) => (a.isMain() ? -1 : 1)),
  }),
  data() {
    return {
      modalOpenState: false,
    };
  },
  mounted() {
    this.$store.dispatch('stripeCard/fetch');
  },
  methods: {
    handleModalClose(e) {
      this.modalOpenState = false;
      if (e && e.success) {
        this.$store.dispatch('stripeCard/fetch');
      }
    },
    openModal() {
      this.modalOpenState = true;
    }
  }
}
</script>

<style scoped>
  .loader {
    height: 120px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/part/card-payment.vue